import React from 'react';

function Separator() {
  return <hr className="my-6 border-gray-200" />;
}

export default Separator;